import { w } from '@tinkoff/statist-page-data';
export var get = function (key) {
    try {
        return w.localStorage.getItem(key);
    }
    catch (_a) {
        return null;
    }
};
export var set = function (key, value) {
    try {
        w.localStorage.setItem(key, value);
        return true;
    }
    catch (_a) {
        return false;
    }
};
export var remove = function (key) {
    try {
        w.localStorage.removeItem(key);
        return true;
    }
    catch (_a) {
        return false;
    }
};
//# sourceMappingURL=local-storage.js.map